import { render, staticRenderFns } from "./SidePanelTable.vue?vue&type=template&id=95b3d26a&scoped=true&"
import script from "./SidePanelTable.vue?vue&type=script&lang=js&"
export * from "./SidePanelTable.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelTable.vue?vue&type=style&index=0&id=95b3d26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b3d26a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
